import { useTranslation, Trans } from 'react-i18next';

// Import styles
import { Wrapper, Title } from './styles';
import { Price } from 'components/views/offer_configurator/components/common/PriceInfo/styles';

// Import types
import type { SummaryProduct } from 'types/views/configurator';
import { PacketSubtype } from 'types/api/products/product';

// Import helpers
import { convertPriceToReadableFormat } from 'helpers/prices';

// Import hooks
import { useConfiguratorContext } from 'components/context/configurator/ConfiguratorProvider';

type Props = {
	isRemoved?: boolean;
	product: Partial<SummaryProduct>;
};

const CartItem = ({ isRemoved = false, product: { subtype, title, current_price, standard_price, promotion } }: Props) => {
	const { t } = useTranslation('configurator');
	const { settings } = useConfiguratorContext();

	const isPromotion = Boolean(promotion);

	const price = isPromotion ? current_price : standard_price;

	return (
		<Wrapper isRemoved={isRemoved}>
			<Title>{subtype === PacketSubtype.Main ? t('offer_packet_main_title', { title }) : title}</Title>
			<Price isPromotion={isPromotion}>
				<Trans
					ns="configurator"
					i18nKey="price_with_duration"
					values={{
						price: convertPriceToReadableFormat(price),
						duration: settings?.billing_duration.period
					}}
				/>
			</Price>
		</Wrapper>
	);
};

export default CartItem;
